import { cx } from '@/utils/cx';
import styles from './CrystalMark.module.scss';

export interface CrystalMarkProps {
  /** Width in px. Height defaults to the same value (square) unless `height` is set. */
  size?: number;
  /** Optional explicit height, for placements that want the mark's natural 100:140 ratio instead of a square crop. */
  height?: number;
  className?: string;
  /** Idle floating animation, used for hero placements. */
  float?: boolean;
  /**
   * When defined, the mark renders in "assembling" mode: facets
   * start invisible/scaled down and animate in once `revealed` is
   * true. Used by the success overlay's purchase-complete moment.
   */
  revealed?: boolean;
  /** Render as a single flat currentColor shape (for badges/pills) instead of the faceted gradient. */
  flat?: boolean;
}

const FACET_FILLS = ['#c9bcfc', '#9b87f5', '#8b74f0', '#7259e8', '#6247d6', '#4e37b8'];

const FACET_PATHS = [
  'M50,5 L22,35 L50,45 Z',
  'M50,5 L78,35 L50,45 Z',
  'M22,35 L50,45 L30,90 Z',
  'M78,35 L50,45 L70,90 Z',
  'M30,90 L50,45 L50,135 Z',
  'M70,90 L50,45 L50,135 Z',
];

export function CrystalMark({ size = 26, height, className, float, revealed, flat }: CrystalMarkProps) {
  const isAssembling = revealed !== undefined;

  return (
    <svg
      viewBox="0 0 100 140"
      width={size}
      height={height ?? size}
      aria-hidden="true"
      className={cx(
        className,
        float && styles.float,
        isAssembling && styles.revealing,
        isAssembling && revealed && styles.revealed,
      )}
    >
      {FACET_PATHS.map((d, i) => (
        <path key={d} className={styles.facet} d={d} fill={flat ? 'currentColor' : FACET_FILLS[i]} opacity={flat ? 0.9 : undefined} />
      ))}
    </svg>
  );
}
